import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
	addShippingAddressThunk,
	addToCartThunk,
	applyVoucherThunk,
	fetchGetCartDetailsThunk,
	getDefaultAddressThunk,
	getOrderSummaryThunk,
	getShippingAddressThunk,
	makePhonePayPaymentThunk,
	removeProductFromCartThunk,
	removeVoucherThunk,
	updateCartQuantityThunk,
	validateSponserIdThunk,
} from '../components/Desktop/Pages/Cart/Apis/cartApis'

const initialState = {
	cart: [],
	productQuantity: 0, // Add productQuantity to the initial state
	cartTotalMRP: 0,
	transactioFee: 0,
	totalAmount: 0,
	transactioFeeValue: 0,

	cartError: null, // Add cartError to the initial state
	successRes: null,
	userShippingAddress: [],
	orderSummary: null,
	phonePayPopUpLocation: null,
	ecomPurchaseLimit: {
		minimum: 0,
		maximum: 0,
	},
}

export const addDatatoCartApi = createAsyncThunk('cart/getsponsoredTeamData', addToCartThunk)

export const removeProductFromCartApi = createAsyncThunk('cart/removeProductFromCartApi', removeProductFromCartThunk)
export const updateCartQuantity = createAsyncThunk('cart/updateCartQuantityThunk', updateCartQuantityThunk)

export const fetchCartDetails = createAsyncThunk('cart/fetchCartDetails', fetchGetCartDetailsThunk)

export const validateSponserId = createAsyncThunk('cart/validateSponserId', validateSponserIdThunk)

export const applyVoucher = createAsyncThunk('cart/applyVoucher', applyVoucherThunk)
export const removeVoucher = createAsyncThunk('cart/removeVoucher', removeVoucherThunk)

export const addShippingAddress = createAsyncThunk('cart/validateSponserId', addShippingAddressThunk)
export const getShippingAddress = createAsyncThunk('cart/addShippingAddress', getShippingAddressThunk)

export const getOrderSummary = createAsyncThunk('cart/getOrderSummary', getOrderSummaryThunk)

export const makePhonePayPayment = createAsyncThunk('cart/makePhonePayPayment', makePhonePayPaymentThunk)

const cartSlice = createSlice({
	name: 'cart',
	initialState,
	reducers: {
		clearCartError(state) {
			state.cartError = null // Action to clear cart error manually if needed
		},
		clearCartSuccessMsg(state) {
			state.successRes = null // Action to clear cart error manually if needed
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchCartDetails.fulfilled, (state, action) => {
			state.cart = action?.payload?.data?.cartDetails // Update the state with the profile data
			state.cartTotalMRP = action?.payload?.data?.cartTotalMRP // Update the state with the profile data
			state.transactioFee = action?.payload?.data?.transactioFee
			state.salarVoucherBalance = action?.payload?.data?.salarVoucherBalance

			state.transactioFeeValue = action?.payload?.data?.transactioFeeValue
			state.ecomPurchaseLimit.maximum = action?.payload?.data?.ecomMaxAmount
			state.ecomPurchaseLimit.minimum = action?.payload?.data?.ecomMinAmount

			state.totalAmount = action?.payload?.data?.totalAmount
			state.productQuantity = action?.payload?.data?.cartDetails.reduce((total, product) => total + product.quantity, 0)
		})
		builder.addCase(getShippingAddress.fulfilled, (state, action) => {
			state.userShippingAddress = action?.payload?.data
		})
		builder.addCase(getOrderSummary.fulfilled, (state, action) => {
			state.orderSummary = action?.payload?.data
		})
		builder.addCase(makePhonePayPayment.fulfilled, (state, action) => {
			if (action?.payload?.status === 1) {
				state.phonePayPopUpLocation = action?.payload?.data?.paymentURL
			}
		})
	},
})

export const { initializeCart, setCart, addToCart, removeFromCart, clearCartError, clearCartSuccessMsg } = cartSlice.actions

export default cartSlice.reducer
